import $ from 'jquery';
import { appconfig } from '../config';

function getPos24ApiConfig() {
    var config = appconfig();

    if (!config || !config.pos24ApiBaseUrl) {
        throw new Error('POS24 API Base Url tanımlı değil.');
    }

    return {
        baseUrl: config.pos24ApiBaseUrl
    };
}

function buildUrl(path) {
    var cfg = getPos24ApiConfig();
    var cleanPath = path.startsWith('/') ? path : '/' + path;
    return cfg.baseUrl + cleanPath;
}

export function postToPos24Api(path, payload, callback, failCallback) {
    var url = '';

    try {
        url = buildUrl(path);
    } catch (err) {
        if (failCallback) {
            failCallback({
                result: false,
                message: err.message,
                data: null
            });
        }
        return;
    }

    $.ajax({
        type: 'POST',
        url: url,
        contentType: 'application/json',
        dataType: 'json',
        data: JSON.stringify(payload)
    })
        .done(function (response) {
            if (callback) callback(response);
        })
        .fail(function (xhr, textStatus, errorThrown) {
            console.error('POS24 API FAIL:', xhr);
            console.log('POS24 API URL:', url);
            console.log('POS24 API textStatus:', textStatus);
            console.log('POS24 API errorThrown:', errorThrown);

            var message = 'API isteği başarısız.';
            var data = null;

            try {
                if (xhr.responseJSON) {
                    message = xhr.responseJSON.message || message;
                    data = xhr.responseJSON.data || null;
                } else if (xhr.responseText) {
                    var parsed = JSON.parse(xhr.responseText);
                    message = parsed.message || message;
                    data = parsed.data || null;
                }
            } catch (e) {
                if (xhr.responseText) {
                    message = xhr.responseText;
                } else if (errorThrown) {
                    message = errorThrown;
                } else if (textStatus) {
                    message = textStatus;
                }
            }

            if (failCallback) {
                failCallback({
                    result: false,
                    message: message,
                    data: data
                });
            }
        });
}



// WEBPACK FOOTER //
// ./app/services/pos24ApiService.js